import React, {Component} from 'react';
import { database, auth } from '../firebase';
import Alert from './Alert';
import Skeleton from "react-loading-skeleton";

class YorumForm extends Component {
    constructor(props) {
        super(props);
        this.database = database.ref().child(`users`);
        this.state = {
          newCommentAuthor: "",
          newCommentContent: "",
          newCommentDate: "",
          asdf: [],
          open: false,

          userImage: "/default_user.jpg",
          userName: ""
        }
        this.writePost = this.writePost.bind(this);
        this.yap = this.yap.bind(this);
    }

    componentDidMount() {
      const previousComments = this.state.asdf;
      this.database.on('child_added', snap => {
        previousComments.push({
          id: snap.key,
          name: snap.val().userName,
          image: snap.val().userImage,
        })
        
        this.setState({
          asdf: previousComments,
        })
      });
    
      this.database.on('child_removed', snap => {
        for (var i = 0; i < previousComments.length; i++) {
          if (previousComments[i].id === snap.key) {
            previousComments.splice(i, 1);
          }
        }
        this.setState({
          asdf: previousComments,
        })
      });
    
      auth.onAuthStateChanged(user => {
        if (auth.currentUser !== null) {
          database.ref("users/" + auth.currentUser.uid).get().then((snap) => {
            this.setState({
              userImage: snap.val().userImage || "/default_user.jpg",
              userName: snap.val().userName || "Unknown User"
            });
          });
        }
      });
    }    

    addComment(yorum) {
      database.ref(`yorumlar/${window.location.pathname.slice(2)}`).push().set({
        commentAuthor: yorum.commentAuthor,
        commentContent: yorum.commentContent,
        commentDate: yorum.commentDate
      });

      database.ref(`posts/${window.location.pathname.slice(2)}`).get().then((snap) => {
        if (auth.currentUser.uid !== snap.val().postAuthor) database.ref("notifications/"+snap.val().postAuthor).push().set({
          author: auth.currentUser.uid,
          date: Date.now(),
          okundu: false,
          post: window.location.pathname.slice(2),
          type: "yorum"
        });
      })
    }

    writePost() {
      if (auth.currentUser === null) return this.yap();
      else if (this.state.newCommentContent == "") return;
      
      var data = {
        commentAuthor: auth.currentUser.uid,
        commentContent: this.state.newCommentContent,
        commentDate: Date.now(),
      };

      if (this.state.newCommentContent = "") alert('Yorum Boş Olamaz')
      else this.addComment(data)

      this.setState({
        newCommentAuthor: "",
        newCommentContent: "",
        newCommentDate: "",
      });
    }

    yap() {
      if (this.state.open == false) this.setState({open: true});
      else this.setState({open: false});
    }

    render() {
      return (
        <div onClick={this.yap}>
          {auth.currentUser == null ? <Alert baslik="Üzgünüm!" 
              content="Bunun için giriş yapman gerekli!" 
              onay="Beni Oraya Götür!" 
              onayLink="/giris-yap"
              red="Anlıyorum..." 
              opened={this.state.open}/> : ""}
    
          <div className="div">
            <h4 className="a" style={{userSelect: "none"}}>Yorum Yap</h4>
    
            <div className="yorum-card-edit" style={{textAlign: "left"}}>
              <a>
                <img 
                  src={this.state.userImage} 
                  className="yorum-image" 
                  id="yorumform-image" 
                  alt="User Avatar"
                />
              </a>
              <div style={{width: "100%"}}>
                <a>
                  <div className="başlık" id="yorumform-name">
                    {this.state.userName ? this.state.userName : <Skeleton width={100} style={{borderRadius: "20px"}} />}  
                  </div>
                </a>
                <textarea 
                  placeholder="Yorum Metni" 
                  value={this.state.newCommentContent} 
                  className="giris" 
                  onChange={event => this.setState({newCommentContent: event.target.value})}
                />
              </div>
              <div>
                <button type="button" className="batın" onClick={this.writePost}>
                  <img src="/sender.png" style={{width: "20px", height: "20px", margin: "0"}}/>
                </button>
              </div>
            </div>
    
            <style>{`
              .div {
                padding: 20px 0;
                background: none;
                width: 100%;
                margin: auto;
                border-top: 2px solid white;
              }
    
              .giris {
                width: calc(100% - 20px);
                height: 40px;
                border: 0;
                margin-top: 5px;
                padding: 10px;
                border-radius: 5px;
                background: rgba(0, 0, 0, .05);
                resize: none;
                outline: none;
                text-align: left;
                font-size: 14px;
              }
    
              .giris::-webkit-scrollbar {
                width: 10px;
                cursor: default;
              }
              
              .giris::-webkit-scrollbar-track {
                background: rgba(0, 0, 0, .2);
                border-radius: 10px;
              }
              
              .giris::-webkit-scrollbar-thumb {
                background: #2f2d33;
                border-radius: 10px;
              }
              
              .giris::-webkit-scrollbar-thumb:hover {
                opacity: .8;
              }
    
              .batın {
                background: #2f2d33;
                border: none;
                border-radius: 100%;
                margin: 100% 10px 0 10px;
                padding: 6px;
                color: #fff;
                display: flex;
                outline: none;
                transition: .2s;
              }
    
              .batın:hover {
                background: #5b5b5c;
              }
    
              .yorum-card-edit {
                border-radius: 10px;
                margin: 10px 0px;
                padding: 0px;
                background: #ffffff;
                width: 100%;
                max-width: 100%;
                height: auto;
                display: flex;
              }
    
              .yorum-card-edit img {
                position: relative;
                margin: 10px;
                border-radius: 50%;
                width: 40px;
                height: 40px;
                object-fit: cover;
              }
    
              .başlık {
                font-size: 13px;
                margin-top: 10px;
                text-align: left;
              }
            `}</style>
          </div>
        </div>
      );
    }
}

export default YorumForm;